import { Reducer } from "redux";

import { GetReferralAuthHistoryActionDispatchTypes } from "../constants/HomePage";
import { ReferralAuthHistoryResponse } from "../models/api/Referral";
import { ReferralAuthHistoryDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: ReferralAuthHistoryResponse = {
  loading: false,
  response: [
    {
      referralId: 0,
      minEffectiveFromDate: "",
      maxEffectiveThroughDate: "",
      serviceProviderId: 0,
      status: "",
      receivedDateTime: "",
      serviceRequestDisciplineId: 0,
      serviceRequestId: 0,
      sn: 0,
      pt: 0,
      ot: 0,
      st: 0,
      msw: 0,
      hha: 0,
    },
  ],
  error: null,
};

const ReferralAuthHistoryReducer: Reducer<
  ReferralAuthHistoryResponse,
  ReferralAuthHistoryDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ReferralAuthHistoryReducer;
